import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// import AppRegistrationIcon from '@mui/icons-material/AppRegistration';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ws1 from './images/WS1.webp';
import ws2 from './images/WS2.webp';
import ws3 from './images/WS3.webp';
import ws4 from './images/WS4.webp';
import ws5 from './images/WS5.webp';
import ws6 from './images/WS6.webp';
import ws7 from './images/WS7.webp';
import ws8 from './images/WS8.webp';
import ws9 from './images/WS9.webp';

const mock = [
    // {
    //   media: image1,
    //   title: 'Meeting Event Manado 2024',
    // },
    // {
    //   media: image4,
    //   title: 'Mechanical Ventilator 1',
    // },
    {
        media: ws1,
        title: 'Acute Heart Failure and Cardiogenic Shock',
    },
    {
        media: ws2,
        title: 'Critical Care Ultrasound and Hemodynamic Assessment',
    },
    {
        media: ws3,
        title: 'Basic Mechanical Ventilation',
    },
    {
        media: ws4,
        title: 'Advance Mechanical Ventilation',
    },
    {
        media: ws5,
        title: 'CRRT in Cardiovascular Critical Care',
    },
    {
        media: ws6,
        title: 'Intra Aortic Balloon Pump',
    },
    {
        media: ws7,
        title: 'Emergency and Critically III ECG',
    },
    {
        media: ws8,
        title: 'Nursing in Cardiovascular Critical Care',
    },
    {
        media: ws9,
        title: 'Acute Coronary Syndrome and Thrombolysis',
    },
];
const Workshop = () => {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
        defaultMatches: true,
    });
    return (
        <Box>
            <Typography
                variant="h4"
                sx={{
                    fontWeight: 'bold',
                }}
                gutterBottom
                align={'center'}
            >
                Workshop
            </Typography>
            <Swiper
                slidesPerView={isMd ? 3 : isSm ? 2 : 1}
                spaceBetween={30}
                loop={true}
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                navigation={true}
                modules={[Pagination, Autoplay, Navigation]}
            >
                {mock.map((item, i) => (
                    <SwiperSlide key={i}>
                        <Box display={'block'} width={1} height={1}>
                            <Box
                                component={Card}
                                width={1}
                                height={1}
                                display={'flex'}
                                flexDirection={'column'}
                            >
                                <CardMedia
                                    sx={{
                                        position: 'relative',
                                        maxWidth: '100%',
                                        maxHeight: 'calc(100vh - 64px)',
                                        overflow: 'hidden',
                                        padding: 0,
                                        paddingBottom: 0,
                                        background:
                                            theme.palette.alternate.main,
                                        display: 'flex',
                                        alignItems: 'flex-end',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Box
                                        component={LazyLoadImage}
                                        effect="blur"
                                        src={item.media}
                                        sx={{
                                            display: 'block',
                                            width: '100%',
                                        }}
                                    />
                                </CardMedia>
                                <CardContent>
                                    <Typography
                                        variant={'subtitle1'}
                                        align={'left'}
                                        sx={{ fontWeight: 700 }}
                                    >
                                        {item.title}
                                    </Typography>
                                    <CardActions
                                        sx={{ justifyContent: 'flex-end' }}
                                    >
                                        {/* <Link to='/signup' style={{ textDecoration: 'none'}}>
                      <Button
                        variant={'contained'}
                        startIcon={
                          <Box
                            component={'svg'}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            width={20}
                            height={20}
                          >
                            <AppRegistrationIcon />
                          </Box>
                        }
                      >
                        Register Now
                      </Button>
                    </Link> */}
                                    </CardActions>
                                </CardContent>
                            </Box>
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
};

export default Workshop;
